export const cardWidthInInches = 3.5;
export const cardHeightInInches = 2.25;
export const cardScale = 1.5;

const scale = 2;
export const cardWidthInPixels = Math.round(cardWidthInInches * 72) * scale;
export const cardHeightInPixels = Math.round(cardHeightInInches * 72) * scale;
